interface Props {
  text: string;
  mouseX: number;
  mouseY: number;
}

export default function CustomCursor({ text, mouseX, mouseY }: Props) {
  const cursorClasses = `hidden lg:inline-flex fixed top-0 left-0 w-[100px] h-[100px] rounded-full bg-white flex items-center justify-center font-bold text-sm transform -translate-x-1/2 -translate-y-1/2 pointer-events-none`;

  return (
    <div className={cursorClasses} style={{ top: `${mouseY}px`, left: `${mouseX}px` }}>
      <span className="gradient-text">{text}</span>
    </div>
  );
}
